module.exports = __webpack_public_path__ + "static/media/ss.29ec746c.svg";